import { msalInstance } from '../auth/msalConfig';

/**
 * Debug function to log the current authentication state
 * Call this from the browser console to see the current state
 */
export const debugAuthState = () => {
  const accounts = msalInstance.getAllAccounts();
  const activeAccount = msalInstance.getActiveAccount();
  
  // Debug info collected without logging
  
  return {
    accounts,
    activeAccount,
    isAuthenticated: accounts.length > 0,
    hasActiveAccount: !!activeAccount
  };
};

// Make it available globally for browser console access
if (typeof window !== 'undefined') {
  window.debugAuthState = debugAuthState;
}

export default debugAuthState;
